export default {
	// FBA.vue
	fba7: '購入待ち',
	fba8: '購入完了',
	fba9: '破棄保留中',
	fba10: '購入不可',
	packList: '梱包伝票',
	logisticsCompany: '物流会社',
	logisticsNo: '追迹番号',
	line: 'ルート',
	packBatchNo: '梱包ロット番号',
	packing: 'パッキン中',
	finishBox: 'パッキング完了',
	toPay: '支払い待ち',
	toUploadInvoice: 'INVOICE アップ中',
	toSend: '発送待ち',
	sent: '発送済み',
	cancelled: 'キャンセル済み',
	toPack: '箱詰待ち',
	airTransportation: '空輸',
	landTransportation: '陸上交通',
	createPackList: '新規梱包伝票',
	packDetail: '梱包詳細',
	pay: '支払い',
	bill: '送料明細',
	orderNo: 'オーダー番号',
	goodsName: '商品名',
	orderState: '注文ステータス',
	warehouseRetention: '倉庫保管',
	goodsNumber: '商品数量',
	productName: '品名',
	packingNumber: '梱包待ち数',
	canBoxCount: '箱詰め可能数',
	canApplyCount: '申請可能数',
	badToHandle: '不良処理待ち',
	exchanging: '交換中',
	reissuing: '再発送中',
	toWarehouse: '入庫待ち',
	warehoused: '到着',
	sampling: '検品中',
	sampled: '検品完了',
	inStorage: '倉庫保管中',
	applyForShipment: '出荷申請',
	badReject: '不良品交換却下',
	exchangeToReturn: '交換品返送待ち',
	exchangeToArrival: '交換して到着を待つ',
	toPartiallyReturned: '一部返品待ち',
	reissueToArrival: '再発行して到着を待つ',
	returnApplying: '返品申請中',
	returnToPay: '返金待ち',
	toReturn: '返品待ち',
	returned: '返品済',
	destroyToApply: '廃棄申請中',
	destroyToPay: '廃棄支払い待ち',
	destroyed: '廃棄済み',
	destroyNumber: '破棄数量',
	returnNumber: '返品数量',
	packNumber: '梱包数量',
	applyNumber: '申し込み数',
	confirmCancelPackList: '梱包伝票をキャンセルしますか？',
	// FBAFill.vue
	billNo: '請求書番号',
	orderType: '受注タイプ',
	project: '項目',
	price: '単価',
	number: '数量',
	discount: '特典/割引',
	amount: '金額',
	totalAmount: '支払総額',
	totalAmount1: "合計金額",
	currentBalance: '現在の残高',
	payNow: '国際送料支払い',
	rechargeTip: '①以下振込先へチャージ金額の振込みをお願いいたします。',
	toRecharge: 'チャージ',
	confirmPay: '支払い注文を確認しますか?',
	// FBAContainerOrder.vue
	addGoods: '商品追加',
	storage: '倉庫保管',
	address: '配送先住所',
	sendAddress: '輸入責任者住所',
	domesticWaybillNo: '国内運送状番号',
	simple: '検品',
	// submitAfterHandle: '内容を記入するか、商品を選択してから提出してください',
	// BoxList.vue
	packNo: '箱番号',
	stocktakeState: '棚卸ステータス',
	unstocktake: '棚卸が完了していません',
	stocktaked: '棚卸完了',
	solidWeight: '実重',
	throwingWeight: 'スリングウェイト',
	bagNumber: '袋数',
	movePack: 'トランスファボックス',
	movedPackNo: '被移箱番号',
	targetBatchNo: 'ターゲットロット番号',
	mergePack: '合箱',
	mergedPackNo: '被合箱番号',
	targetPackNo: 'ターゲットボックス番号',
	selectTargetBatch: 'ターゲットロットを選択してください',
	// BoxOrderList.vue
	notStocktake: '未棚卸',
	stocktakeResolve: '棚卸完了',
	stocktakeReject: '棚卸未完了',
	packDate: '梱包日',
	packPerson: '箱詰担当',
	orderDate: 'オーダー日',
	color: '色',
	size: 'サイズ',
	fba1: '明細書',
	fba2: '発送日',
	fba3: '箱数',
	fba4: '受取人の郵便番号',
	fba5: '輸入責任者情報',
	batchNo: 'ロット番号',
	boxCount: '箱の数',
	totalNetWeight: '商品の総重量',
	totalRealWeight: '総実重',
	totalThrowWeight: '総容積',
	goodsNetWeight: '商品の重さ',
	boxRealWeight: '箱の実重量',
	boxThrowWeight: '箱の容積重量',
	netWeight: '実重量',
	fba11: "コード",
	totalGoods: '商品価格 とオプション料金',
	fbaa1: '※新規梱包伝票作成時の商品一覧です。',
	fbaa2: '※この費用はオーダーから自動的に差し引かれます。',
	fbaa3: '※倉庫保管料は梱包ロット発送時に自動控除されます。',
	fbaa4: '※個別メッセージにて追加発送依頼があった品目については含まれておりません。',
	billDownLoad: '明細ダウンロード',
	boxDownLoad: '明細ダウンロード',
	downLoad1: "ダウンロード中",
  downLoad2: "ダウンロード完了",
  downLoad3: "輸送箱梱包明細",
};
